import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import * as R from 'ramda'
import './TextInput.module.scss'

class TextInput extends Component {
  onKeyPress = (event) => {
    const { field } = this.props
    const name = R.prop('name', field)
    const digits = '1234567890'

    if (name === 'telephone') {
      const keyCode = event.keyCode || event.which
      const keyValue = String.fromCharCode(keyCode)
      const type = R.includes(keyValue.toString(), digits.split(''))
      if (!type) {
        event.preventDefault()
      }
    }
  }

  render () {
    const {
      field: { name, ...field },
      form: { touched, errors },
      label,
      type,
      ...props } = this.props

    const error = R.prop(name, errors)
    const touch = R.prop(name, touched)
    const showError = touch && error

    return (
      <div styleName='field'>
        <label htmlFor={name} styleName='label'>{label}</label>
        {type === 'textarea' ? (
          <textarea
            id={name}
            styleName={classnames('input', 'textarea',
              { 'accepted': touch && !showError },
              { 'error': showError }
            )}
            type={type}
            {...field}
            {...props}
          />
        ) : (
          <input
            id={name}
            styleName={classnames('input',
              { 'error': showError },
              { 'accepted': touch && !showError }
            )}
            type={type}
            onKeyPress={this.onKeyPress}
            {...field}
            {...props}
          />
        )}
        {showError && <span styleName='warning'>{error}</span>}
      </div>
    )
  }
}

TextInput.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
}

export default TextInput



// WEBPACK FOOTER //
// ./src/components/Form/TextInput/TextInput.js